
import Vue from "vue";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";

interface DataType {
  contentTop: string;
  mainHeight: string;
}

interface MethodType {
  init: () => void;
  calcHeight: () => void;
}

interface ComputedType {
  contentStyle: () => any;
}

export default Vue.extend({
  name: "KitamiRine",
  data(): DataType {
    return {
      contentTop: "0px",
      mainHeight: "5000px",
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      setTimeout(() => {
        this.calcHeight();
      }, 500);
    },
    calcHeight() {
      const main = document.getElementById("main-container");
      const contentTop = Math.ceil(main!.clientWidth * 1.1);
      this.contentTop = contentTop + "px";

      const cb = document.getElementById("content-block");
      this.mainHeight = `${contentTop + cb!.clientHeight + 20}px`;
      console.log("calcHeight", this.contentTop, this.mainHeight);
    },
  },
  computed: {
    contentStyle() {
      return {
        top: this.contentTop,
      };
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, DataType, MethodType, ComputedType, unknown>);
